import Select from 'react-select-4';
import { constructCourseDetails } from 'admin/domains/teacherTrials/utils';
import { useCourseSelector } from 'core/hooks';

/* eslint-disable react/prop-types */ // TODO: add props

export const CourseSelector = ({
  courseIds = [], // Optional list of course IDs to override the default course options
  selected = [], // Array containing selected course options
  onChange, // param passed to onChange will be the selected option, or an array of options if isMulti is true
  placeholder = 'Select a course',
  instanceId = 'course-selector',
  customStyles = {
    container: (provided, state) => ({
      ...provided,
      top: 0,
      zIndex: '3 !important',
    }),
    control: (provided, state) => ({
      ...provided,
      minWidth: 200,
    }),

    menu: (provided) => ({
      ...provided,
      minWidth: 700,
    }),
  },
  selectRef = null,
  filterOption = null,
  isMulti = false,
  required = false,
  styles = {},
  ...props
}) => {
  const { courseOptions, isLoading, searchForWordsAndFilterByYear } =
    useCourseSelector();
  let filteredCourseOptions = courseOptions || [];

  // Filter course options by list of course IDs if provided, show all the courses otherwise
  if (courseIds.length > 0) {
    filteredCourseOptions = courseOptions.filter((courseOption) => {
      return courseIds.includes(courseOption.course_id);
    });
  }

  // currently selected course option(s)
  const value = filteredCourseOptions.filter((courseOption) =>
    selected.includes(courseOption.course_id)
  );

  return (
    <Select
      ref={selectRef}
      options={filteredCourseOptions}
      value={value}
      isLoading={isLoading}
      clearable
      onChange={onChange}
      placeholder={placeholder}
      instanceId={instanceId}
      filterOption={filterOption ? filterOption : searchForWordsAndFilterByYear}
      getOptionLabel={(courseOption) => constructCourseDetails(courseOption)}
      getOptionValue={(option) => {
        return option.course_id;
      }}
      menuPlacement="auto"
      menuPosition="fixed"
      styles={{ ...customStyles, ...styles }}
      isMulti={isMulti}
      // TODO: Upgrade to `react-select-5` because `isRequired` is not supported in `react-select-4`!!!
      isRequired={required}
      {...props}
    />
  );
};
